import { SET_USER_PANEL, SET_POINTS_CONVERTION } from './types.js'
import axios from 'axios'

export default {
  async requestUserPanel({commit}) {
    await axios.get('api/settings/modules')
      .then(response => {
        commit(SET_USER_PANEL, response.data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  async requestConvertionSettings({commit}) {
    await axios.get('api/settings/point-convertion')
      .then(response => {
        commit(SET_POINTS_CONVERTION, response.data.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  async convertPoints(context, param) {
    await axios.post('api/user/point-convertion', param)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  }
}